export function RolesTab() {
  return (
    <div className="space-y-6">
      <div className="rounded-xl shadow-card dark:shadow-card-dark bg-paper-card dark:bg-[#292524] overflow-hidden">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b border-line bg-soft/50 text-ink-2">
              <th className="px-6 py-4 font-semibold">Role Name</th>
              <th className="px-6 py-4 font-semibold">Description</th>
              <th className="px-6 py-4 font-semibold">Role Type</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-line">
            <tr className="transition-colors hover:bg-soft/30">
              <td className="px-6 py-4 font-medium text-ink">Owner</td>
              <td className="px-6 py-4 text-ink-2">
                Full control over workspace resources and members. Complete access to all features including billing, user management, and organization settings.
              </td>
              <td className="px-6 py-4 text-ink-3">System</td>
            </tr>
            <tr className="transition-colors hover:bg-soft/30">
              <td className="px-6 py-4 font-medium text-ink">Member</td>
              <td className="px-6 py-4 text-ink-2">
                Granular access controlled by the Owner. Can only view and edit features explicitly granted in their permissions. Cannot manage billing or users.
              </td>
              <td className="px-6 py-4 text-ink-3">System</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
